/**
 * @owner @Appboy/frontend-ix
 */

/**
 * @scaffoldversion 0.0.0
 */

import ErrorBoundary from "./ErrorBoundary";

export default ErrorBoundary;
export * from "./ErrorBoundary";
export * from "./WithErrorBoundary";
export * from "./types";
